/**
 * @Copyright(c) 2017-2024 捷杰传感
 * @Author（创建人） 顾建东
 * @Date（创建时间） 2026/10/12
 * @Description（类描述）: 温度补偿接口
 * @Version（版本）: v1.0
 * @DemandAddress（需求地址）：
 */

import axios from '../axios'
import type {
    ITemperatureCompensationBatchUpdateParams,
    ITemperatureCompensationDetailParams,
    ITemperatureCompensationPageData,
    ITemperatureCompensationPageParams,
    ITemperatureCompensationRecord,
    ITemperatureCompensationTrendData,
    ITemperatureCompensationTrendParams,
    ITemperatureCompensationUpdateParams,
} from './temperatureCompensation.types'

/** 分页查询温度补偿列表 */
export function temperatureCompensationPage(params: ITemperatureCompensationPageParams = {}) {
    return axios<ITemperatureCompensationPageData>({
        method: 'get',
        url: '/temperature/compensation/page',
        params,
    })
}

/** 查询传感器温度补偿详情 */
export function temperatureCompensationDetail(params: ITemperatureCompensationDetailParams) {
    return axios<ITemperatureCompensationRecord>({
        method: 'get',
        url: '/temperature/compensation/detail',
        params,
    })
}

/** 查询指定传感器的温度趋势 */
export function temperatureCompensationTrend(params: ITemperatureCompensationTrendParams) {
    return axios<ITemperatureCompensationTrendData>({
        method: 'get',
        url: '/temperature/compensation/trend',
        params,
    })
}

/** 修改单个传感器温度补偿公式 */
export function temperatureCompensationUpdate(params: ITemperatureCompensationUpdateParams) {
    return axios<void>({
        method: 'put',
        url: '/temperature/compensation/update',
        data: params,
    })
}

/** 批量统一修改传感器温度补偿公式 */
export function temperatureCompensationBatchUpdate(params: ITemperatureCompensationBatchUpdateParams) {
    return axios<number>({
        method: 'put',
        url: '/temperature/compensation/batchUpdate',
        data: params,
    })
}
